<template>
	<Spiner />
</template>

<script>
import Spiner from '../components/UI/Spinner.vue';
import appUrl from '../store/appUrl';
export default {
	components: {
		Spiner,
	},

	async created() {
		let postValue = {};
		if (localStorage.isLogin) {
			postValue = {
				code: this.$route.query.code,
				auth: 'login',
			};
			localStorage.removeItem('isLogin');
		} else {
			postValue = {
				oauth_token: this.$route.query.oauth_token,
				oauth_verifier: this.$route.query.oauth_verifier,
			};
		}
		try {
			let response = await this.$http.post('auth/register/twitter', postValue, { withCredentials: true });
			if (response.data.img) {
				window.location.replace(appUrl + `?token=${response.data.token}&img=${response.data.img}`);
			} else {
				window.location.replace(appUrl + `?token=${response.data.token}`);
			}
		} catch (error) {
			if (error?.data?.message === 'User not found') {
				alert('User is not registered');
				this.$router.push({ name: 'main' });
			}
		}
	},
};
</script>

<style>
</style>